const ITEMS = [
  "Personal Training",
  "Private Lessons",
  "Soccer Coaching",
  "Online Classes",
  "Strength · Conditioning",
  "Youth Athlete Development",
  "Nutrition Guidance",
];

export default function Marquee() {
  const loop = [...ITEMS, ...ITEMS];
  return (
    <section
      data-testid="marquee"
      className="border-y border-white/10 bg-[#0a0a0a] overflow-hidden py-6"
    >
      <div className="flex animate-marquee whitespace-nowrap">
        {loop.map((t, i) => (
          <div
            key={i}
            className="flex items-center gap-6 mx-6 font-display text-2xl md:text-3xl uppercase tracking-wider"
          >
            <span className="text-white/90">{t}</span>
            <span className="text-[#FF3B30]">✦</span>
          </div>
        ))}
      </div>
    </section>
  );
}
